import React from "react";
var __jsx = React.createElement;
import stl from "./SquareSlider.module.css";
import { CMSImageHelper } from '@/utils/CMSHelpers';
var SingleSquareSlider = function SingleSquareSlider(_ref) {
  var _cardData$bg_color, _cardData$image, _cardData$title;
  var cardData = _ref.cardData;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.singleCarContainer,
    style: {
      backgroundColor: (_cardData$bg_color = cardData === null || cardData === void 0 ? void 0 : cardData.bg_color) !== null && _cardData$bg_color !== void 0 ? _cardData$bg_color : "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.SCImageContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: CMSImageHelper(cardData === null || cardData === void 0 ? void 0 : (_cardData$image = cardData.image) === null || _cardData$image === void 0 ? void 0 : _cardData$image.url),
    loading: cardData === null || cardData === void 0 ? void 0 : cardData.image_loading_behavior,
    alt: (_cardData$title = cardData === null || cardData === void 0 ? void 0 : cardData.title) !== null && _cardData$title !== void 0 ? _cardData$title : "image",
    width: 164,
    height: 124
  })), /*#__PURE__*/React.createElement("h3", null, cardData === null || cardData === void 0 ? void 0 : cardData.title), /*#__PURE__*/React.createElement("p", null, cardData === null || cardData === void 0 ? void 0 : cardData.description));
};
export default SingleSquareSlider;